import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AudienceApiService, AudienceChangelogEvent } from '../../../../services/audience-api.service';

/**
 * Changelog tab of the advanced "Additional Info" card. Rebuilt from admin-dashboard
 * `audience-insights-details`: the audience's change history (the backend already resolves UserName).
 */
@Component({
  selector: 'app-audience-changelog-tab',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './audience-changelog-tab.component.html',
  styleUrls: ['./audience-changelog-tab.component.scss']
})
export class AudienceChangelogTabComponent implements OnChanges {
  @Input() audienceId: string | null = null;

  events: AudienceChangelogEvent[] = [];
  loading = false;
  error = false;

  private loadedFor: string | null = null;

  constructor(private audienceApi: AudienceApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['audienceId'] && this.audienceId && this.audienceId !== this.loadedFor) {
      this.load(this.audienceId);
    }
  }

  private load(audienceId: string): void {
    this.loadedFor = audienceId;
    this.loading = true;
    this.error = false;
    this.events = [];
    this.audienceApi.getAudienceChangelog(audienceId).subscribe({
      next: (rows) => {
        if (this.loadedFor !== audienceId) {
          return;
        }
        this.events = rows;
        this.loading = false;
      },
      error: () => {
        if (this.loadedFor !== audienceId) {
          return;
        }
        this.error = true;
        this.loading = false;
      }
    });
  }

  formatDate(date: string): string {
    if (!date) {
      return '—';
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return date;
    }
    return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  trackByIndex(index: number): number {
    return index;
  }
}
